(() => {
// Include custom styles.

document.addEventListener('DOMContentLoaded', function() {
    console.log("Init complete.");
});

})();
//# sourceMappingURL=page.js.map
